const cards = [
  {
    id: 'card-1',
    title: '长安十二时辰',
    tag: '热播古装',
    desc: '大唐盛世风云再起，惊天阴谋一触即发。易烊千玺、雷佳音领衔主演，口碑爆棚年度古装巨制。',
    rating: '9.2',
    views: '3.2亿',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20poster%20style%2C%20Tang%20dynasty%20warrior%20in%20red%20and%20gold%20armor%2C%20dramatic%20lighting%2C%20cinematic%20film%20aesthetic%2C%20dark%20moody%20background%20with%20palace%20silhouette%2C%20warm%20golden%20tones%2C%20high%20contrast%2C%20epic%20atmosphere&width=600&height=840&seq=juzi-card-01&orientation=portrait',
  },
  {
    id: 'card-2',
    title: '流浪地球3',
    tag: '科幻巨制',
    desc: '人类命运共同体开启新征程，太阳危机终极对决。国产科幻巅峰之作，视觉震撼前所未有。',
    rating: '9.5',
    views: '5.8亿',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%2C%20astronaut%20floating%20in%20deep%20space%20with%20glowing%20blue%20nebula%2C%20massive%20spaceship%20in%20background%2C%20cinematic%20lighting%2C%20dark%20cosmic%20atmosphere%2C%20epic%20scale%2C%20dramatic%20composition&width=600&height=840&seq=juzi-card-02&orientation=portrait',
  },
  {
    id: 'card-3',
    title: '繁花似锦',
    tag: '都市情感',
    desc: '上海滩风云际会，商海沉浮中的人性较量。胡歌、马伊琍领衔，王家卫监制年度大剧。',
    rating: '8.9',
    views: '2.6亿',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20modern%20drama%20poster%2C%20couple%20in%20stylish%20attire%20walking%20through%20Shanghai%20street%20at%20night%2C%20neon%20lights%2C%20romantic%20atmosphere%2C%20film%20noir%20aesthetic%2C%20warm%20golden%20street%20lamps%2C%20cinematic%20quality&width=600&height=840&seq=juzi-card-03&orientation=portrait',
  },
  {
    id: 'card-4',
    title: '深海迷踪',
    tag: '悬疑惊悚',
    desc: '深海科考队神秘失踪，海底万米隐藏惊天秘密。沉浸式深海冒险，每一帧都令人窒息。',
    rating: '8.7',
    views: '1.9亿',
    img: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20thriller%20movie%20poster%2C%20dark%20underwater%20scene%20with%20mysterious%20glowing%20creature%2C%20submarine%20silhouette%2C%20deep%20blue%20and%20teal%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20underwater%20lighting%2C%20bubbles%20and%20particles&width=600&height=840&seq=juzi-card-04&orientation=portrait',
  },
  {
    id: 'card-5',
    title: '破晓行动',
    tag: '动作犯罪',
    desc: '跨国缉毒大案真实改编，特警突击队雷霆出击。全程高能无尿点，硬核国产动作片标杆。',
    rating: '9.0',
    views: '4.1亿',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20action%20crime%20film%20poster%2C%20special%20forces%20soldier%20in%20tactical%20gear%2C%20urban%20night%20scene%20with%20explosions%2C%20dramatic%20orange%20and%20dark%20tones%2C%20intense%20cinematic%20style%2C%20rainy%20street%20atmosphere%2C%20powerful%20composition&width=600&height=840&seq=juzi-card-05&orientation=portrait',
  },
  {
    id: 'card-6',
    title: '山河令',
    tag: '仙侠传奇',
    desc: '江湖儿女情长，仙魔大战一触即发。匠心打造东方奇幻世界，绝美视效与动人故事完美结合。',
    rating: '8.8',
    views: '3.5亿',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%2C%20elegant%20warrior%20with%20flowing%20robes%20on%20mountain%20peak%2C%20cherry%20blossoms%20floating%2C%20misty%20atmosphere%2C%20soft%20ethereal%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20poetic%20composition&width=600&height=840&seq=juzi-card-06&orientation=portrait',
  },
  {
    id: 'card-7',
    title: '猎罪图鉴',
    tag: '刑侦悬疑',
    desc: '模拟画像师与刑警队长联手破案，每个案件都暗藏人性拷问。烧脑推理与视觉奇观兼备。',
    rating: '9.1',
    views: '2.8亿',
    img: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20drama%20poster%2C%20detective%20sketching%20in%20dimly%20lit%20room%2C%20evidence%20board%20with%20red%20strings%2C%20noir%20atmosphere%2C%20dark%20moody%20lighting%2C%20suspenseful%20cinematic%20style%2C%20shadow%20and%20light%20contrast&width=600&height=840&seq=juzi-card-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-black text-foreground-50">热门推荐</h2>
            <p className="text-foreground-500 text-sm mt-1">精选高分好剧，每日更新</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hidden sm:inline-flex items-center gap-1.5 text-primary-400 text-sm font-medium cursor-pointer hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-[10px] font-bold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-2 right-2 w-8 h-8 rounded-lg bg-background-50/80 flex items-center justify-center">
                  <span className="text-foreground-50 text-xs font-black">{card.rating}</span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-3">
                <h3 className="text-foreground-100 font-bold text-sm leading-tight">{card.title}</h3>
                <p className="text-foreground-600 text-[11px] mt-1 leading-relaxed line-clamp-2">{card.desc}</p>
                <div className="flex items-center gap-1 mt-2">
                  <i className="ri-eye-line text-foreground-600 text-[10px]"></i>
                  <span className="text-foreground-600 text-[10px]">{card.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}